
















import { Component, Vue } from 'vue-property-decorator';
import AppMain from './components/AppMain/index.vue';
import AppNavbar from './components/AppNavbar/index.vue';
import AppSidebar from './components/AppSidebar/index.vue';
import GlobalOverlay from '@/components/global/Overlay/index.vue';

// import ResizeMixin from './mixin/resize';
import { UserModule } from '@/store/modules/user';

@Component({
  name: 'Layout',
  components: {
    AppMain,
    AppNavbar,
    AppSidebar,
    GlobalOverlay,
  },
})
// export default class extends mixins(ResizeMixin) {
export default class extends Vue {}
